/*
 * Filename: template-configuration-root.component.tsx
 * Description: Landing page for template configuration.
 */

import React, { Component, ReactNode } from 'react';
import CQLightningStudioHeader from '../cq-header/cq-header';
import { CQTemplateConfigurationBodyContainer } from './template-configuration-body.component';
import './template-config.css';
import { LSTemplatesStore } from '../../store/ls-template-store';
import { CQAppConstant } from '../../app-constants';

export class CQTemplateConfigurationRoot extends Component<{ history: any }, any>{

    componentDidMount() {
        const isTemplateDataEmpty = (Object.keys(LSTemplatesStore.selectedTemplate).length === 0 && LSTemplatesStore.selectedTemplate.constructor === Object);
        if (isTemplateDataEmpty) {
            this.props.history.push(CQAppConstant.NAVIGATION.TEMPLATES);
        }
    }

    public render(): ReactNode {
        const isTemplateDataEmpty = (Object.keys(LSTemplatesStore.selectedTemplate).length === 0 && LSTemplatesStore.selectedTemplate.constructor === Object);
        return (
            <div className="slds-grid slds-grid_vertical full-height">
                <CQLightningStudioHeader />
                {
                    !isTemplateDataEmpty &&
                    <CQTemplateConfigurationBodyContainer {...this.props} />
                }
            </div>
        );
    }

}
